import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const mailCodeOfferComponent = {
  originalPayment: 'mail-code-offer.originalPayment',
  originalPaymentLabel: 'mail-code-offer.originalPaymentLabel',
  refinancePayment: 'mail-code-offer.refinancePayment',
  refinancePaymentLabel: 'mail-code-offer.refinancePaymentLabel',
  root: 'mail-code-offer.root',
  savingsAmount: 'mail-code-offer.savingsAmount',
  savingsAmountLabel: 'mail-code-offer.savingsAmountLabel',
} as const satisfies ComponentLocatorMap;
